export function userOptions(state) {
  const users = state.users
    .map(res => {
      let prefix = ""
      if (res.prefix) {
        prefix = res.prefix.nameTh
      }
      return {label: prefix + res.name + " " + res.surname, value: res.id}
    })
  return users ? users : []
}

